export function mobileNoValidation(number) {
    let pattern = "[0-9]{8,18}";
    let mobile_new_pattern = new RegExp("^[0-9]{8,18}$");
    if (number.length < 7) return "Invalid Mobile Number";
    else if (number.length > 21) return "Invalid Mobile Number"; 
    else if (!number.match(pattern)) return "Invalid Mobile Number"; //REGEX CHECK ONLY NUMERIC
    else if (!mobile_new_pattern.test(number)) return "Invalid Mobile Number"; //REGEX CHECK ONLY NUMERIC
    else return "" // NO Errors
  }

  export function emailValidation(email) {
    let pattern = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i)
    if (!pattern.test(email)) return "Invalid Email Address!"
    else return ""
  }
  